export default "__VITE_ASSET__DXk8jto9__"